import * as React from "react";
function SvgGrip(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M10.1 0h10v10h-10V0zm0 19h10v10h-10V19zm0 19h10v10h-10V38zM27.9 0h10v10h-10V0zm0 19h10v10h-10V19zm0 19h10v10h-10V38z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGrip);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
